import React from 'react'
import BigAdd from './BigAdd'
import SocialMediaShare from './SocialMediaShare'
import DhamSansar from './DhamSansar'
// import Astrology from './Astrology'
import EkaDashi from './EkaDashi'
import RashifalVerticle from './RashifalVerticle'
import ButtonTags from './ButtonTags'
// import './style1.css';

function DainikRashifalDetails() {
    return (
        <div>
            <div className="ak-post-wrapper" style={{ transform: "none" }}>
                <div
                    className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
                    style={{ transform: "none" }}
                >
                    <div className="ak-container" style={{ transform: "none" }}>

                        <div className="ak-content" style={{ transform: "none" }}>
                            <div className="containercustome" style={{ transform: "none" }}>
                                <div className='mt-2'>
                                    <BigAdd />
                                </div>
                                <div className="row grid-container" style={{ transform: "none" }}>
                                    <div
                                        className="grid-item ak_column_1 col-md-3 sidebar-column sidebar-column-primary sticky-sidebar "
                                        style={{
                                            position: "relative",
                                            overflow: "visible",
                                            boxSizing: "border-box",
                                            minHeight: 1
                                        }}
                                    >
                                        <div
                                            className="theiaStickySidebar"
                                            style={{
                                                paddingTop: 0,
                                                paddingBottom: 1,
                                                position: "sticky",
                                                transform: "none",
                                                top: 0,
                                                left: "914.5px"
                                            }}
                                        >
                                            <div className="sidebar post-sidebar">


                                                <RashifalVerticle />

                                                <SocialMediaShare />


                                            </div>
                                            <div
                                                className="resize-sensor"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                    zIndex: -1,
                                                    visibility: "hidden"
                                                }}
                                            >
                                                <div
                                                    className="resize-sensor-expand"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "all 0s ease 0s",
                                                            width: 410,
                                                            height: 1260
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="resize-sensor-shrink"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "0s",
                                                            width: "200%",
                                                            height: "200%"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid-item ak_column_2 col-md-6 mt-4 " >
                                        <div style={{
                                            paddingTop: 0,
                                            paddingBottom: 1,
                                            position: "sticky",
                                            transform: "none",
                                            top: 0,
                                            left: "914.5px"
                                        }}>

                                            <div className="ak-article-inner" >

                                                <div className="ak_column_2 col-md-12">

                                                    <header className="entry-header ak-post-header mb-2">
                                                        <div className="ak-post-badges" />

                                                        <h1 className="ak-post-title mt-2">
                                                            सोना पहली बार ₹74 हजार के पार: चांदी ने ₹92,444 का ऑल
                                                        </h1>
                                                        <div className="ak-post-summary mb-2">
                                                            सोना और चांदी ने आज यानी 21 मई को ऑल टाइम हाई बनाया है। इंडिया बुलियन एंड ज्वेलर्स एसोसिएशन (IBJA) की वेबसाइट के मुताबिक, कारोबार
                                                        </div>

                                                    </header>
                                                    <div className="ak-article-inner">

                                                        <div className="ak-article-inner">
                                                            <div className="ak-post-featured">
                                                                <div className="ak-featured-cover">
                                                                    <a href="wp-content/uploads/sites/26/2022/10/post-18.jpg">
                                                                        <div
                                                                            className="ak-featured-thumb  size-auto"
                                                                            style={{ paddingBottom: "50%" }}
                                                                        >
                                                                            <img
                                                                                width={750}
                                                                                height={375}
                                                                                src=""
                                                                                className="attachment-newsy_750x375 size-newsy_750x375 wp-post-image lazyautosizes lazyloaded"
                                                                                alt=""
                                                                                decoding="async"
                                                                                fetchpriority="high"
                                                                                data-src=""
                                                                                data-sizes="auto"
                                                                                data-srcset=""
                                                                                data-expand={700}
                                                                                sizes="750px"
                                                                                srcSet=""
                                                                            />
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>



                                                            <div className="ak-post-content">
                                                                <p className="" id="">
                                                                    रिजर्व बैंक ऑफ इंडिया यानी RBI ने ब्रिटेन से अपना 100 टन (करीब 1 लाख किलो) सोना वापस मंगा लिया है। यह 1991 की शुरुआत के बाद पहली बार है, जब इतना अधिक सोना भारत के भंडार में वापस आया है।
                                                                </p>
                                                                <p>
                                                                    लेटेस्ट डेटा के अनुसार, मार्च 2024 के अंत तक RBI के पास कुल 822.1 टन सोना था, जिसमें से 413.8 टन विदेशों में जमा था। RBI पिछले कुछ सालों में सोना खरीदने वाले केंद्रीय बैंकों में से एक है। पिछले वित्त वर्ष में रिजर्व बैंक के सोने के भंडार में 27.5 टन सोना बढ़ा है।    100 टन सोने को भारत लाने के लिए महीनों की प्लानिंग की गई और फिर पूरे प्लान को एग्जीक्यूट किया गया। प्लानिंग और एग्जीक्यूशन में वित्त मंत्रालय, RBI और सरकार की अन्य विंग के साथ लोकल अथॉरटीज शामिल रहीं।     RBI को सोना भारत में लाने के लिए सीमा शुल्क में छूट मिली। लेकिन आयात पर लगने वाले इंटीग्रेटेड GST में कोई छूट नहीं दी गई। ऐसा इसलिए क्योंकि इस टैक्स को राज्यों के साथ शेयर किया जाता है।   अगर भारत में आपदा या राजनीतिक अस्थिरता से आर्थिक स्थिति खराब होती है तो इससे उबरने में विदेशों में रखा सोना काम आता है। प्राकृतिक आपदाओं से भी सोने के भंडार को नुकसान पहुंच सकता है। अलग-अलग जगह सोना रखने से यह जोखिम कम होता है।
                                                                </p>


                                                                <p>ब्रिटेन का बैंक ऑफ इंग्लैंड परंपरागत रूप से कई केंद्रीय बैंकों के लिए सोने का भंडारगृह रहा है। भारत की आजादी से पहले से ही कुछ मात्रा में सोना लंदन में जमा है,भारत ने कुछ सोना लंदन में ही रखा हुआ है।</p>
                                                                <p>100 टन सोने को भारत लाने के लिए महीनों की प्लानिंग की गई और फिर पूरे प्लान को एग्जीक्यूट किया गया। प्लानिंग और एग्जीक्यूशन में वित्त मंत्रालय, RBI और सरकार की अन्य विंग के साथ लोकल अथॉरटीज शामिल रहीं।     RBI को सोना भारत में लाने के लिए सीमा शुल्क में छूट मिली। लेकिन आयात पर लगने वाले इंटीग्रेटेड GST में कोई छूट नहीं दी गई। ऐसा इसलिए क्योंकि इस टैक्स को राज्यों के साथ शेयर किया जाता है।   अगर भारत में आपदा या राजनीतिक अस्थिरता से आर्थिक स्थिति खराब होती है तो इससे उबरने में विदेशों में रखा सोना काम आता है। प्राकृतिक आपदाओं से भी सोने के भंडार को नुकसान पहुंच सकता है। अलग-अलग जगह सोना रखने से यह जोखिम कम होता है।</p>
                                                            </div>
                                                        </div>



                                                    </div>
                                                    <ButtonTags />
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                    <div
                                        className="grid-item ak_column_1 col-md-3 content-column sidebar-column sidebar-column-primary-right sticky-sidebar"
                                        style={{
                                            position: "relative",
                                            overflow: "visible",
                                            boxSizing: "border-box",
                                            minHeight: 1
                                        }}
                                    >
                                        <div
                                            className="stickybar"
                                            style={{
                                                paddingTop: 0,
                                                paddingBottom: 1,
                                                position: "sticky",
                                                transform: "none",
                                                top: 0,
                                                left: "914.5px"
                                            }}
                                        >
                                            <div className="sidebar post-sidebar">
                                                <div className='mt-2'>
                                                    <DhamSansar />
                                                </div>
                                                {/* <Astrology /> */}
                                                <EkaDashi />



                                            </div>

                                            <div
                                                className="resize-sensor"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                    zIndex: -1,
                                                    visibility: "hidden"
                                                }}
                                            >
                                                <div
                                                    className="resize-sensor-expand"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "all 0s ease 0s",
                                                            width: 410,
                                                            height: 1260
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="resize-sensor-shrink"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "0s",
                                                            width: "200%",
                                                            height: "200%"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>


        </div>
    )
}

export default DainikRashifalDetails
